import { render } from "./LoaderInsideWithText.vue?vue&type=template&id=26187e90&scoped=true"
import script from "./LoaderInsideWithText.vue?vue&type=script&lang=js"
export * from "./LoaderInsideWithText.vue?vue&type=script&lang=js"

import "./LoaderInsideWithText.vue?vue&type=style&index=0&id=26187e90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26187e90"]])

export default __exports__